define([
    'text!app-locale',
    'moment'
], (locales, moment)=> {
    return ['$translate', 'LOCALE_INFO', '$rootScope', 'tmhDynamicLocale', '$q', ($translate, LOCALE_INFO, $rootScope, tmhDynamicLocale, $q)=> {
        /*--- VARS ---*/
        const localesObj = LOCALE_INFO.locales;
        const missingLocales = {};


        // get locales and locales display names
        const _LOCALES = Object.keys(localesObj);
        if (!_LOCALES || _LOCALES.length === 0) {
            console.error('There are no _LOCALES provided');
        }
        const _LOCALES_DISPLAY_NAMES = [];
        _LOCALES.forEach((locale)=> {
            _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
        });

        /**
         * A promise for when angular-translate is loaded and translations are provided
         * @type {Q.Promise}
         */
        const translateReadyDeferred = $q.defer();

        const localeInfo = JSON.parse(locales);
        const currencySymbols = {
            'aud': '$',
            'cad': '$',
            'eur': '\u20ac',
            'gbp': '\u00a3',
            'jpy': '\u00a5',
            'rub': '\u20BD',
            'usd': '$',
            'chf': 'Fr.',
            'cny': '\u00a5',
            'nzd': '$'
        };

        let currentLocale;

        /*--- METHODS ---*/
        const checkLocaleIsValid = (locale)=> {
            return _LOCALES.indexOf(locale) !== -1;
        };

        const onSettingLocale = (locale)=> {
            document.mp$currentLocale = locale;// set global var
            document.documentElement.setAttribute('lang', locale.replace('_', '-'));// set "lang" attribute to html
        };

        const setLocale = (locale)=> {
            if (!checkLocaleIsValid(locale)) {
                console.error(`Locale name "${locale}" is invalid`);
                return;
            }
            startLoadingAnimation();
            currentLocale = locale;
            $translate.use(locale);
        };

        /**
         * Stop application loading animation when translations are loaded
         */
        const $html = angular.element('html');
        const LOADING_CLASS = 'app-loading';

        function startLoadingAnimation() {
            $html.addClass(LOADING_CLASS);
        }

        function stopLoadingAnimation() {
            $html.removeClass(LOADING_CLASS);
        }

        /*--- EVENTS ---*/
        $rootScope.$on('$translateChangeSuccess', (event, data)=> {
            onSettingLocale(data.language);
            const localeComponents = data.language.split('_');
            const countryCode = localeInfo.country.code.toLowerCase();
            if (localeComponents.length > 1) {
                localeComponents[1] = countryCode;
            } else {
                localeComponents.push(countryCode);
            }
            const localeCode = `${localeComponents[0]}-${localeComponents[1]}`;
            const replacementCode = missingLocales[localeCode];

            /**
             * Set locale for moment.js (is used in datepicker component)
             * moment.js is loaded with locale included => synchronous change
             */
            if (moment.locale(localeCode) !== localeCode) {// if locale isn't provided by moment.js

                if (localeComponents[0] === 'zh') { //no moment zh.js default to zh-cn.js

                    moment.locale('zh-cn');
                } else {
                    moment.locale(localeComponents[0]);// language
                }
            }

            tmhDynamicLocale.set(replacementCode || localeCode);// load Angular locale

            translateReadyDeferred.resolve();
        });

        $rootScope.$on('$localeChangeSuccess', ()=> {
            stopLoadingAnimation();
        });

        $rootScope.$on('$localeChangeError', (event, data)=> {
            const comp = data.split('-');
            if (comp.length > 1) {
                missingLocales[data] = comp[0];
                tmhDynamicLocale.set(comp[0]);
            } else {
                stopLoadingAnimation();
            }
        });

        /*--- INIT ---*/
        function onInit() {
            // store current locale
            currentLocale = $translate.proposedLanguage() || $translate.use();// because of async loading
            onSettingLocale(currentLocale);
        }

        onInit();

        /*--- RETURN ---*/
        return {
            getCountry: ()=> {
                return localeInfo.country;
            },
            getLocaleDisplayName: ()=> {
                return localesObj[currentLocale];
            },
            setLocaleByDisplayName: (localeDisplayName)=> {
                setLocale(
                    _LOCALES[
                        _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)// get locale index
                        ]
                );
            },
            getCurrentLocale: ()=> {
                return currentLocale;
            },

            getCurrentLanguage: ()=> {
                if (currentLocale) {
                    if (currentLocale.indexOf('_') > -1) {
                        return currentLocale.split('_').shift();
                    }

                    return currentLocale;
                }

                throw new Error('Unknown language');
            },

            getLocalesDisplayNames: ()=> {
                return _LOCALES_DISPLAY_NAMES;
            },
            getCurrencySymbol: (currency)=> {
                return currencySymbols[currency] || '\u00A4';
            },
            getNameConfig: ()=> {
                return localeInfo.name;
            },
            getAddressConfig: ()=> {
                return localeInfo.address;
            },
            getLocaleInfo: ()=> {
                return localeInfo;
            },
            getRegionSamplePhoneNumber: ()=> {
                return localeInfo.phone.sample;
            },
            getConfiguredPhoneRegion: ()=> {
                return localeInfo.phone.UserDefaultPhoneCountry;
            },

            whenTranslateReady: ()=> {
                return translateReadyDeferred.promise;
            }
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/l10n/LocaleService.js
 **/